import React, { useEffect } from 'react';
import { Box, Chip, Divider, Typography, Button, useMediaQuery, Tab, Tabs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import {SectionTitle} from '../components/SectionTitle';
import { Today, EventAvailable, PeopleAltOutlined, Twitter, Facebook,WhatsApp, StarBorder, LocalOffer, ChevronRight, ChevronLeft } from '@mui/icons-material';
import Header from '../components/Header';
import IconWrapper from '../components/IconWrapper';
import useServiceDetails from '../../shared/logic/useServiceDetails';
import ImageGallery from 'react-image-gallery';
import CustomBreadCrumbs from '../components/CustomBreadcrumbs';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { PhotoPreview } from 'src/components/white-label-component/company-comp';
import AppointmentBook from '../../shared/components/AppointmentBook/AppointmentBook';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import { db } from 'src/config/firebase';
import { Rating } from '@mui/material';
import moment from 'moment';
import CustomMetaData from 'src/hooks/CustomMetaData';
import imgProfile2 from '../../../../../assets/images/templates/profile.png';
import imgProfile from '../../../../../assets/images/templates/profile.jpg';
import { serviceDetailsImage, serviceDetailsImageMB } from '../../shared/logic/imagesFns';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { createMarkup } from '../../shared/logic/Utils';
import useRTL from 'src/hooks/useRTL';
import { calculateRating } from 'src/config/RatingCalculation';
import "react-image-gallery/styles/css/image-gallery.css";
import { theme } from '../Template';
import { textVariant, textClasses } from '../../shared/config';
import youtubeVideo from '../../../../../assets/images/templates/t4/youtube.png';
import AppointmentIcon from '../../../../../assets/images/templates/t3/appointment.svg';
import AppointmentMBIcon from '../../../../../assets/images/templates/t3/appointmentMb.svg';
import LocationIcon from '../../../../../assets/images/templates/t3/location.svg';
import CalendarIcon from '../../../../../assets/images/templates/t3/calendar.svg';
import LocationMBIcon from '../../../../../assets/images/templates/t3/locationMb.png';
import PlayIcon from 'src/assets/images/templates/t3/play.png';

// Custom style tab and tabs
const CustomTabs = withStyles({
  root: {
    border:'1px solid #E4E7EB',
    backgroundColor: '#fac400',
    boxShadow:'0px 1px 3px #00000029',
    padding:'0px 10px',
    minHeight:'76px',
  },

  flexContainer:{
    height:'100%'
  },

  indicator: {
    backgroundColor: '#fac400',
  },
})(Tabs);
const CustomTab = withStyles((theme) => ({
  root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontSize:"18px",
      color:'#fff',
      '&:hover': {
          color: '#fff',
          opacity: 1,
      },
      '&$selected': {
          color: '#fff',
      },
      '&:focus': {
          color: '#fff',
      },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useRatingStyles = makeStyles((theme) => ({
  root:{
    fontSize:'1.5rem !important',
    [theme.breakpoints.down('sm')]:{
      fontSize:'1rem !important'
    }
  },

  iconFilled:{
    color: '#fac400 !important',
  },

  iconHover:{
    color: '#fac400',
  },

  iconEmpty:{
    color: '#fac400 !important',
  },

  icon:{
    display:'unset !important'
  }
}));


const useStyles = makeStyles(() => ({
  breadOl:{
    justifyContent:'center'
  },

  shareDiv:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    width:'35px',
    height:'35px',
    borderRadius:'50%',
    border: '1px solid #e3e3e3',
    backgroundColor:'transparent',
    cursor:'pointer',
    margin:'16px 5px 5px 5px',
    '& svg':{
      color:'#fff',
      fontSize:'1rem'
    },

    "&:hover":{
      border: '1px solid #17C799',
      backgroundColor:'#17C799'
    },
  },

  indicator: props=>({
    backgroundColor: props.buttonFontColor ? props.buttonFontColor : "#fac400",
  }),

  galleryClass:{
    '& .image-gallery-content': {
      '& .image-gallery-slide-wrapper': {
          '& .image-gallery-left-nav':{
            display: 'none !important',
          },
          '& .image-gallery-right-nav':{
            display: 'none !important',
          },

          '& .image-gallery-swipe':{
            '& .image-gallery-slides':{
              // height: '300px !important',
              // maxHeight: '300px !important',
              borderRadius: '0px !important',
              [theme.breakpoints.down('md')]:{
                width:'100% !important',
                borderRadius: '0px !important',
                height: '300px'
              },

              '& .image-gallery-slide':{
                backgroundColor: '#c1c5cb12',
                height:'390px !important',
                borderRadius: '0px !important',
                // height: '300px !important',
                // maxHeight: '300px !important',
                [theme.breakpoints.down('md')]:{
                  borderRadius: '0px !important',
                  height: 'auto',
                  maxHeight:'300px',
                  backgroundColor:'#fff'
                },

                '& .image-gallery-image':{
                  borderRadius: '0px !important',

                  height:'100% !important',
                  // maxHeight: '300px !important',
                  // maxHeight:'300px !important',
                  // height:'300px !important',
                  // [theme.breakpoints.down('sm')]:{
                  //   maxHeight: ' !important',
                  // }
                }
              },
            },
          }
      }
    },

    '& .image-gallery-thumbnails .image-gallery-thumbnails-container':{
      display:'flex',
      alignItems:'flex-start'
    },

    '& .image-gallery-thumbnail .image-gallery-thumbnail-image':{
      height:'60px',
      maxHeight:'60px',
      objectFit:'contain'
    }
  },

  showmoreBtn:{
    border:'none',
    outline:'none',
    backgroundColor:'transparent',
    color:'#15476D',
    cursor:'pointer'
  },

  descSpan:{
    paddingTop:'25px',
    fontSize:'16px',
    color:'#818181',
    textOverflow:'ellipsis',
    '& li':{
      listStyle:'inherit'
    },

    [theme.breakpoints.down('sm')]:{
      paddingTop:'16px', 
    }
  },

  scheduleBtns:{
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    width:'calc(100% - 46px)',
    minHeight:'88px',
    padding:'0px 23px',
    backgroundColor:'#FAFAFA',
    border:'1px solid #E7E7E7',
    [theme.breakpoints.down('sm')]:{
      minHeight:'66px'
    }
  },

  iconImg:{
    width:'44px',
    height:'44px',
    '& img':{
      width:'100%',
      height:'100%',
    }
  },

  playBtn:{
    width:'90px',
    height:'90px',
    position:'absolute',
    top:0,
    bottom:0,
    margin:'auto',
    zIndex:10,
    display:'none',
    cursor:'pointer',
    [theme.breakpoints.down('sm')]:{
      display:'block'
    },

    '& img':{
      width:'100%',
      height:'100%'
    }
  },

  customInfoSpanDiv:{
    display:'flex',
    flexDirection:'column',
    width:'calc(100% - 70px)',
    maxWidth:'calc(100% - 70px)',
    // whiteSpace:'nowrap',
    // overflow:'hidden',
    // textOverflow:'ellipsis'
  },

  iconMbImg:{
    width:'11px',
    '& img':{
      width:'100%',
      height:'100%',
    }
  },

  gpCustomCls:{
    marginTop:'100px'
  },

  appointCustomCls:{
    marginBottom:'100px'
  },

  headerArrowBtn:{
    outline:'none',
    border:'1px solid #DDDDDD',
    backgroundColor:'#FFFFFF',
    color:'#928F8F',
    width:'30px',
    height:'30px',
    borderRadius:'50%',
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center',
    position:'absolute',
    top:0,
    bottom:0,
    margin:'auto 0',
    zIndex:10,
  }
}));

const ServiceDetails = () => {
  const [activeTab, setActiveTab] = React.useState('one');
  const { service, groups, reviews, photos, videoEmbedSrc, handleBooking, t, schedule } =
    useServiceDetails();
  const [, isRTL,  fontFamily] = useRTL();
  const { data } = useCompanyData();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const xsMatches = useMediaQuery(theme.breakpoints.down('sm'));
  const { id } = service || {};
  const { buttonColor, buttonFontColor, companyData }= data || {};
  const currentTime = moment().unix();

  const course = groups?.length ? groups.filter(v=> v.groupType === 'course')?.[0] : {};
  const handleChange = (event, newValue) => { // tab click event
    setActiveTab(newValue);
  };

  useEffect(()=> {

    setActiveTab('one');

  },[xsMatches])

  const showAllReviews = () => {
    window.scrollTo(0,0);
    setActiveTab('three');
  }

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[id]);

  const isSchduleConvertCurrency = schedule?.convertCurrency && schedule?.displayPrice && schedule?.displayCurrency;
  const isCourseConvertCurrency = course?.convertCurrency && course?.displayPrice && course?.displayCurrency;

  return (
    <div style={xsMatches ? { position:'relative' } : {}}>
      <CustomMetaData
        {...{
          title: `${companyData?.name} - ${service?.name}`,
          image: companyData && companyData.avatar,
          description: service?.description
        }}
      />
      <ServiceDetailsHeader
        online={service?.online}
        title={service?.name}
        image={xsMatches ? serviceDetailsImageMB(service,photos,videoEmbedSrc) : serviceDetailsImage(service, photos)}
        reviews={reviews}
        data={data}
        service={service}
        fontFamily={fontFamily}
        matches={xsMatches}
        schedule={schedule}
        course={course}
      />

      {!xsMatches ? <TabButtons activeTab={activeTab} fontFamily={fontFamily} buttonColor={buttonColor} schedule={schedule} course={course} buttonFontColor={buttonFontColor} handleChange={handleChange} t={t} isRTL={isRTL} /> : null}
      {xsMatches ?
      <Box
        width="100%"
        borderRadius="20px 20px 0px 0px"
        bgcolor="#fff"
        position="absolute"
        top="280px"
      > 
        <Box 
          width="90%"
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          justifyContent="space-between"
          m="auto"
          mt="23px"
        >
          {schedule ?
          <Box display="flex" flexDirection="column">
            <Typography style={{fontFamily,fontSize:'12px',color:'#928F8F'}}>{t && t('companyPage.startFrom')}</Typography>

            <span style={{fontSize:'25px',color:'#15476D',textTransform:'uppercase',fontWeight:'bold',marginTop:'9px'}}>
              {isSchduleConvertCurrency ?
              `${schedule.displayPrice} ${schedule.displayCurrency}` :
              `${(schedule.offer || schedule.offerValidity > currentTime) ? schedule.offerPrice : schedule.groupPrice} ${schedule.currency}`}
            </span>
              {schedule.offer || schedule.offerValidity > currentTime ? (
                <span
                    style={{ textDecoration: 'line-through',fontSize:'16px',color:'#9E9E9E',fontFamily}}
                  >
                    {schedule.groupPrice} {schedule.currency}
                  </span>
                  )
              : null
              }
              {isSchduleConvertCurrency ?
              <span style={{fontSize:'16px',color:'#000',fontFamily}}>
                {`Pay ${schedule.groupPrice} ${schedule.currency}`}
              </span>
              : null}
          </Box>
          :
          course ?
          <Box display="flex" flexDirection="column">
            <Typography style={{fontFamily,fontSize:'12px',color:'#928F8F'}}>{t && t('companyPage.startFrom')}</Typography>

            <span style={{fontSize:'25px',color:'#15476D',textTransform:'uppercase',fontWeight:'bold',marginTop:'9px'}}>
              {isCourseConvertCurrency ?
              `${course.displayPrice} ${course.displayCurrency}` :
              `${(course.offer || course.offerValidity > currentTime) ? course.offerPrice : course.groupPrice} ${course.currency}`}
            </span>
              {course.offer || course.offerValidity > currentTime ? (
                <span
                    style={{ textDecoration: 'line-through',fontSize:'16px',color:'#9E9E9E',fontFamily}}
                  >
                    {course.groupPrice} {course.currency}
                  </span>
                  )
              : null
              }
              {isCourseConvertCurrency ?
              <span style={{fontSize:'16px',color:'#000',fontFamily}}>
                {`Pay ${course.groupPrice} ${course.currency}`}
              </span>
              : null}
          </Box>
          : 
          <Box></Box>
          }

          <InstructorMBInfo memberId={service?.serviceDeliver} data={data}/>
        </Box>
      </Box>
      : null}
      <Overview
        name={service?.name}
        videos={videoEmbedSrc}
        photos={photos}
        service={service}
        groups={groups}
        reviews={reviews}
        handleBooking={handleBooking}
        fontFamily={fontFamily}
        matches={matches}
        xsMatches={xsMatches}
        schedule={schedule}
        course={course}
        serviceId={id}
        data={data}
        activeTab={activeTab}
        t={t}
        isRTL={isRTL}
      />

      {/* {activeTab === 0 ?
      <Box
        py={5}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        width="90%"
        m="auto"
      >
        {/* {schedule ? <AppointmentWrapper schedule={schedule} serviceId={id} data={data} t={t} fontFamily={fontFamily}/> : null} */}
        {/* <Box mr={3} width={{ xs: '100%', lg: '75%' }}>

          {groups?.length ?
          <Groups t={t} groups={groups} fontFamily={fontFamily} data={data} matches={matches} handleBooking={handleBooking} />
          : null}

          {reviews.length > 0 ? 
            <>
            <Reviews reviews={reviews} t={t} data={data} matches={matches} />
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <CustomButton
                style={{backgroundColor: buttonColor ? buttonColor : 'inherit',color:buttonFontColor ? buttonFontColor : 'inherit'}}
                variant="contained"
                onClick={showAllReviews}
              >
                {t && t('companyPage.exploreServices')}
              </CustomButton>
            </Box>
            </>
          :
          null
          }
        </Box> */}
      {/* </Box>
      : null} */}

    </div>
  );
};

const ServiceDetailsHeader = ({ online, title, image, reviews,data, service, matches, schedule, course }) => {
  const { t, displayBanner=true, generalTitleFontSize } = data;
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [previewDialog, setPreviewDialog] = React.useState(false);
  const [activeImg, setActiveImg] = React.useState('');
  const [_fileType, setFileType] = React.useState('image');
  const variant = generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  const onNextClick = () => {
    if(currentIndex !== image.length - 1) {
      setCurrentIndex(idx => idx + 1);
    }
  }
  
  //Handler to update the current index on click of left button
  const onPreviousClick = () => {
    if(currentIndex !== 0) {
      setCurrentIndex(idx => idx - 1);
    }
  };

  const previewEvent = (img,fileType) => {
    setPreviewDialog(true);
    setActiveImg(img);
    setFileType(fileType);
  };

  const playEvent = () => {
    setPreviewDialog(true);
    setActiveImg(image[currentIndex]?.['path']);
    setFileType('video');
  };

  const closeDialog = () => {
    setPreviewDialog(false);
    setActiveImg('');
    setFileType('image');
  };

  return (
    <>
    <Header
    image={matches ? image?.length ? image[currentIndex]?.['path'] : service?.cover : image}
    height={"495px"}
    mbHeight={'290px'}
    transparencyColor={'#15476db2'}
    bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
    displayBanner={displayBanner}
    data={data}
    position="relsative"
    {...(matches ? {customGradient:true} : {})}
    onClickEvent={()=> previewEvent(matches ? image?.length ? image[currentIndex]?.['path'] : service?.cover : image,'image')}
    customStyle={matches ? {alignItems:'flex-end',position:'relative'} : {}}
    >
      {matches ? <button className={classes.headerArrowBtn} style={{left:'5px',display: currentIndex === 0 ? 'none' : 'block'}} onClick={onPreviousClick}><ChevronLeft /></button> : null}
      {matches && image[currentIndex]?.['video'] ?
      <div className={classes.playBtn} onClick={playEvent}>
        <img src={PlayIcon} alt='play' />
      </div>
      : null}
      <div style={{zIndex:1}}>
        <Box pb={{xs: '5px', md: "25px"}} mt={{xs:'0px', md:"185px"}}>
          <Typography
            variant={variant}
            className={fontSizeCls}
            style={{
              color: 'white',
              fontWeight: 'bold',
              width: matches ? '95%' : '85%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: 'auto',
            }}
          >
            {title}
          </Typography>
        </Box>
          
        {!matches ? <CustomBreadCrumbs title={t && t('companyPage.services')} /> : null}

        <InstructorInfo memberId={service?.serviceDeliver} matches={matches} schedule={schedule} course={course} t={t} reviews={reviews} online={online} data={data}  />
      </div>
      {matches ?<button className={classes.headerArrowBtn} style={{right:'5px',display: currentIndex === image?.length - 1 ? 'none' : 'block'}} onClick={onNextClick}><ChevronRight /></button> : null}
    </Header>
      {previewDialog && activeImg ? <PhotoPreview dataArray={[{path:activeImg,type:_fileType}]} closeEvent={closeDialog} /> : null}
    </>
  );
};

const OverviewSectionTitle = ({ children, ...props }) => {
  const [, isRTL, ] = useRTL();
  const borderStyle = isRTL ? {borderRight:'6px solid rgb(22, 70, 109)'} : {borderLeft:'6px solid rgb(22, 70, 109)'};
  return (
    <Box pb={3} {...props}>
      <Typography variant="h6" style={{ color: '#16466d', fontWeight: 600, fontSize:'1.125rem',padding:`0px ${isRTL ? '10px' :'0px'} 0px ${isRTL ? '0px' :'10px'}`,...borderStyle}}>
        {children}
      </Typography>
    </Box>
  );
};

const Overview = ({
  name,
  service,
  groups,
  photos,
  reviews,
  videos,
  handleBooking,
  fontFamily,
  schedule,
  course,
  matches,
  data,
  activeTab,
  isRTL,
  t,
  serviceId,
  xsMatches
}) => {
  const [showVideo,setShowVideo] = React.useState({});
  const classes = useStyles();
  const [showMore, setShowMore] = React.useState(false);
  const [buttonClick, setButtonClick] = React.useState(false);
  const descDivRef = React.useRef(null);
  const { id:scheduleId } = schedule || {};
  const { id:courseId } = course || {};
  const currentTime = moment().unix();
  const { buttonColor } = data || {};

  const showMoreEvent = () => {
    setShowMore(!showMore);
    if(!buttonClick) setButtonClick(true);
  };

  const _renderVideo = (item) => {

    const _toggleShowVideo = (url) => {
      setShowVideo({
        ...showVideo,
        [url]: !showVideo[url]
      });
    };

    return (
      <div>
        <div style={{position: 'relative',padding: '33.35% 0',height: 0}}>
            <a
              className='close-video'
              onClick={() => _toggleShowVideo(item.embedUrl)}
            >
            </a>
            <iframe
              width='100%'
              height={matches ? '100%' : '300px'}
              src={item.embedUrl}
              frameBorder='0'
              allowFullScreen
              style={{position:'absolute',top:0,left:0}}
            >
            </iframe>
        </div>
      </div>
    );
  };

  let images = [
    {
      original:service?.cover,
      thumbnail:service?.cover,
      loading:"lazy",
      originalAlt:service?.name,
      thumbnailAlt:service?.name
    }
  ];

  if(videos.length > 0) {
    videos.forEach(v => {
      var obj = {
        original:youtubeVideo,
        thumbnail:youtubeVideo,
        embedUrl: v,
        originalAlt:service?.name,
        thumbnailAlt:service?.name,
        renderItem: () => _renderVideo({
          original:youtubeVideo,
          thumbnail:youtubeVideo,
          embedUrl: v,
          originalAlt:service?.name,
          thumbnailAlt:service?.name,})
      };
      images.push(obj)
    })
  };

  if(photos.length > 0) {
    photos.forEach(v => images.push({
      original:v.photoPath,
      thumbnail:v.photoPath,
      loading:"lazy",
      originalAlt:service?.name,
      thumbnailAlt:service?.name
    }))
  };

  const descDivOffsetHeight = descDivRef?.current?.offsetHeight;
  const descDivScrollHeight = descDivRef?.current?.scrollHeight;

  const DescShowBtn = () => (
    <button
      className={classes.showmoreBtn}
      style={{fontFamily,color: buttonColor || '#15476D'}}
      onClick={showMoreEvent}>
        {showMore ? t && t('companyPage.showless') : t && t('companyPage.showmore')}
    </button>
  );

  const isSchduleConvertCurrency = schedule?.convertCurrency && schedule?.displayPrice && schedule?.displayCurrency;
  const isCourseConvertCurrency = course?.convertCurrency && course?.displayPrice && course?.displayCurrency;

  return (
    <Box
      py={10}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="90%"
      m="auto"
      mt={xsMatches ? '60px' : 'auto'}
    >
      {activeTab === 'one' ?
      <>
      <Box 
        display="flex"
        flexDirection={{xs:'column', md:'row'}}
        justifyContent="space-between"
        width="100%"
        m="auto"
      >

        {xsMatches ?
        schedule ?
        <CustomInfoDiv 
          mt="40px"
          {...{iconImg:LocationIcon, title:t && t('new_company.location'),subTitle: schedule.location === 'Online video Conference' ? t && t('companyPage.online') : schedule.locationAddress || t && t('companyPage.offline')}}
        />
        :
        course ?
        <>
          <CustomInfoDiv 
            mt="40px"
            {...{iconImg: CalendarIcon, textTransform:'normal', title:t && t('companyPage.dateTime'),subTitle: `${course.startDate ? moment(new Date(course?.startDate*1000)).format('D/MM/YYYY') : '---'} ${t && t('companyPage.to')} ${course.endDate ? moment(new Date(course.endDate*1000)).format('D/MM/YYYY') : '---'}`}}
          />
          <CustomInfoDiv 
            mt="8px"
            {...{iconImg:LocationIcon, title:t && t('new_company.location'),subTitle: course.location === 'Online video Conference' ? t && t('companyPage.online') : course.locationAddress || t && t('companyPage.offline')}}
          />
        </>
        : null
        :null
        }
        <Box width={{xs: '100%', md: '400px', lg:'533px'}} display={xsMatches ? 'none' : 'flex'}>
          <Box overflow="hidden" style={{width:'100%'}}>
            <ImageGallery
              items={images}
              showPlayButton={false}
              showFullscreenButton={false}
              additionalClass={classes.galleryClass}
            />
          </Box>
        </Box>
        <Box width={{xs:'100%', md: 'calc(100% - 457px)', lg:'calc(100% - 590px)'}}>
          <Typography
            variant="h2"
            style={{
              color: '#000',
              fontWeight: 'bold',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: 'auto',
              fontSize:'1.875em',
              display: xsMatches ? 'none' : 'block'
            }}
          >
            {service?.name || '---'}
          </Typography>

          {schedule && scheduleId ?
          <>
          <span style={{
            fontSize:'20px',
            color:'#000000',
            display: xsMatches ? 'none' : 'block',
            fontFamily
          }}>{t && t('companyPage.appointment')}</span>

          <Typography style={{
            fontSize:'16px',
            color:'#928F8F',
            display: xsMatches ? 'none' : 'block',
            fontFamily,
            marginTop:'28px'
          }}>{t && t('companyPage.startFrom')}</Typography>

          <Box display={xsMatches ? 'none' : 'flex'} flexDirection="row" alignItems="center">
            <span style={{fontSize:'25px',color:'#15476D',textTransform:'uppercase',fontWeight:'bold',padding:`0px ${isRTL ? '0px' : '20px'} 0px ${isRTL ? '20px' : '0px'}`}}>
              {isSchduleConvertCurrency ? 
              `${schedule.displayPrice} ${schedule.displayCurrency}` :
              `${(schedule.offer || schedule.offerValidity > currentTime) ? schedule.offerPrice : schedule.groupPrice} ${schedule.currency}`}
            </span>
            {schedule.offer || schedule.offerValidity > currentTime ? (
              <span
                  style={{ textDecoration: 'line-through',fontSize:'16px',color:'#9E9E9E',fontFamily}}
                >
                  {schedule.groupPrice} {schedule.currency}
                </span>
                )
            : null
            }
          </Box>
          {isSchduleConvertCurrency ?
          <span style={{fontSize:'16px',color:'#000',fontFamily,display:xsMatches ? 'none' : 'flex'}}>
            {`Pay ${schedule.groupPrice} ${schedule.currency}`}
          </span>
          : null}

          </>
          : course && courseId ?
          <>
          <span style={{
            fontSize:'20px',
            color:'#000000',
            display: xsMatches ? 'none' : 'block',
            fontFamily
          }}>{t && t('acti-comp.cat-option.event')}</span>

          <Typography style={{
            fontSize:'16px',
            color:'#928F8F',
            display: xsMatches ? 'none' : 'block',
            fontFamily,
            marginTop:'28px'
          }}>{t && t('companyPage.startFrom')}</Typography>

          <Box display={xsMatches ? 'none' : 'flex'} flexDirection="row" alignItems="center">
            <span style={{fontSize:'25px',color:'#15476D',textTransform:'uppercase',fontWeight:'bold',padding:`0px ${isRTL ? '0px' : '20px'} 0px ${isRTL ? '20px' : '0px'}`}}>
            {isCourseConvertCurrency ? 
              `${course.displayPrice} ${course.displayCurrency}` :
              `${(course.offer || course.offerValidity > currentTime) ? course.offerPrice : course.groupPrice} ${course.currency}`}
            </span>
            {course.offer || course.offerValidity > currentTime ? (
              <span
                  style={{ textDecoration: 'line-through',fontSize:'16px',color:'#9E9E9E',fontFamily}}
                >
                  {course.groupPrice} {course.currency}
                </span>
                )
            : null
            }
          </Box>
          {isCourseConvertCurrency ?
          <span style={{fontSize:'16px',color:'#000',fontFamily,display:xsMatches ? 'none' : 'flex'}}>
            {`Pay ${course.groupPrice} ${course.currency}`}
          </span>
          : null}
          </>
          :null
          }

          <Box style={ ((!schedule && !scheduleId) && (!course && !courseId)) ? {} : {paddingTop: xsMatches ? '71px' : "60px" }} >
            <OverviewSectionTitle pb={0} isRTL={isRTL}>
              {t && t('companyPage.description')}
            </OverviewSectionTitle>
            <Typography variant="body1" className={classes.descSpan} style={{maxHeight: showMore ? 'fit-content' : xsMatches ? '138px' : '190px',overflow: showMore ? 'unset' : 'hidden'}} ref={descDivRef} dangerouslySetInnerHTML={createMarkup(service?.shortDescription)}></Typography>
            {descDivOffsetHeight > descDivScrollHeight ? null :
            descDivOffsetHeight < descDivScrollHeight ? <DescShowBtn /> : buttonClick ? <DescShowBtn /> : null }
          </Box>
        </Box>
      </Box>

      <Box 
        display="flex"
        flexDirection={{xs:'column', md:'row'}}
        justifyContent="space-between"
        width="100%"
        m="auto"
        mt="74px"
        alignItems="flex-start"
      >
        <Box width={{xs: '100%', md: '400px', lg:'533px'}} display={xsMatches ? 'none' : 'block'}>
          {schedule && scheduleId ?
            <>
              <CustomInfoDiv 
                {...{iconImg:AppointmentIcon, title:t && t('activityPage.book'),subTitle: t && t('companyPage.appointment')}}
              />

              <CustomInfoDiv 
                mt="23px"
                {...{iconImg:LocationIcon, title:t && t('new_company.location'),subTitle: schedule.location === 'Online video Conference' ? t && t('companyPage.online') : schedule.locationAddress || t && t('companyPage.offline')}}
              />
            </>
          :
          course && courseId ?
            <>
              <CustomInfoDiv 
                {...{iconImg:AppointmentIcon, title:t && t('activityPage.book'),subTitle: t && t('acti-comp.cat-option.event')}}
              />

              <CustomInfoDiv 
                mt="23px"
                {...{iconImg: CalendarIcon, textTransform:'normal', title:t && t('companyPage.dateTime'),subTitle: `${course.startDate ? moment(new Date(course?.startDate*1000)).format('D/MM/YYYY') : '---'} ${t && t('companyPage.to')} ${course.endDate ? moment(new Date(course.endDate*1000)).format('D/MM/YYYY') : '---'}`}}
              />

              <CustomInfoDiv 
                mt="23px"
                {...{iconImg:LocationIcon, title:t && t('new_company.location'),subTitle: course.location === 'Online video Conference' ? t && t('companyPage.online') : course.locationAddress || t && t('companyPage.offline')}}
              />
            </>
            : null}
        </Box>

        <Box width={{xs:'100%', md: 'calc(100% - 457px)', lg:'calc(100% - 590px)'}}>
          {schedule ? <AppointmentWrapper schedule={schedule} serviceId={serviceId} data={data} t={t} fontFamily={fontFamily}/> : null}

          {!schedule ? <Groups t={t} groups={groups} data={data} fontFamily={fontFamily} matches={matches} handleBooking={handleBooking} /> : null}

          {reviews.length > 0 ? <Reviews reviews={reviews} t={t} data={data} matches={matches} customCls={classes.gpCustomCls} /> : null}
        </Box>
      </Box>
      </>
      :
      <Box mr={3} width={{ xs: '100%', lg: '75%' }}>
        { 
        activeTab === 'two' && !schedule ?
          <Groups t={t} groups={groups} data={data} fontFamily={fontFamily} matches={matches} handleBooking={handleBooking} />
        :
        activeTab === 'three' ?
        reviews.length > 0 ? <Reviews reviews={reviews} t={t} data={data} matches={matches} />
        :
        reviews?.length < 1 && (
          <Typography style={{fontFamily}}>{t && t('companyPage.sorryNoReviews')}</Typography>
        )
        : null
        }
      </Box>
      }
    </Box>
  );
};

const AppointmentWrapper = ({ schedule, data, t, fontFamily, serviceId }) => {
  const classes = useStyles();
  const calendarBg ="#FAC400";
  const calendarBgHover = "#fac40057";
  const calendarColor = "#fff";
  return (
    <Box width="100%" pb={3} className={classes.appointCustomCls}>
      <OverviewSectionTitle>
        {t && t('services.sh-section.selectDateTime')}
      </OverviewSectionTitle>
      <AppointmentBook schedule={schedule} calendarBg={calendarBg} calendarBgHover={calendarBgHover} calendarColor={calendarColor} serviceId={serviceId} data={data} t={t} fontFamily={fontFamily}/>   
    </Box>
  );
};

const Groups = ({ groups, handleBooking, t,fontFamily,matches, data, customCls }) => {
  const { setPage, count, currentItems } = useMyPagination(groups, 4);

  return (
    <Box width="100%" pb={3} className={customCls || ''}>
      <OverviewSectionTitle>
        {t && t('component.sidebar.school-info5')}
      </OverviewSectionTitle>
      <div>
        {currentItems?.map((item, i) => (
          <GroupItem
            key={i}
            group={item}
            data={data}
            handleBooking={handleBooking}
            matches={matches}
            fontFamily={fontFamily}
            isLast={i === groups.length - 1}
            t={t}
          />
        ))}
        {groups?.length < 1 && (
          <Typography>{t && t('companyPage.sorryNoGroups')}</Typography>
        )}
      </div>
      <MyPagination count={count} onChange={setPage} />
    </Box>
  );
};

const GroupItem = ({ group, handleBooking, t, fontFamily,matches,data }) => {
  const currentTime = moment().unix();
  const  { buttonColor, buttonFontColor } = data || {};
  const offer = (group.offer && group.offerValidity > currentTime);
  const isAvailable = group.groupType === 'course' ? group.endDate > currentTime : true; 
  const isConvertCurrency = group?.convertCurrency && group?.displayPrice && group?.displayCurrency;
  return (
    <Box mb="15px" px="10px" py="15px" width="calc(100% - 20px)" style={{border:'1px solid #E7E7E7',backgroundColor:'#FAFAFA'}}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
        flexDirection={matches ? 'row' : 'column'}
        mb={1}>
        <SectionTitle pb={0} pFontSize="18"
        style={{
          textTransform: 'capitalize',
          textOverflow: "ellipsis",
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          color:'#0F2240'
        }}
        width={matches ? '70%' : '100%'}
        maxWidth={matches ? '70%' : '100%'}

        >
          {group.name}
        </SectionTitle>
        <Box display="flex" flexDirection="column" 
        py={{ xs: 1, lg: 0 }}
        width={ matches ? 'auto' : '100%' }
        alignItems={!matches ? 'flex-end' :"center"}
        justifyContent={!matches ? 'flex-end' : ''}
        >
            <Box
            py={{ xs: 1, lg: 0 }}
            width={ matches ? 'auto' : '100%' }
            display="flex"
            alignItems="center"
            justifyContent={!matches ? 'flex-end' : ''}
          >
            <SectionTitle pFontSize="18" style={{paddingBottom:'0px'}}>
              {isConvertCurrency ?
              `${group.displayCurrency} ${group.displayPrice}` :
              `${group.currency} ${offer ? group.offerPrice : group.groupPrice}`}
            </SectionTitle>
              {offer ? (
                <SectionTitle
                  pFontSize="14"
                  mx={2}
                  style={{ textDecoration: 'line-through', opacity: '0.4',paddingBottom:'0px' }}
                >
                  {group.currency} {group.groupPrice}
                </SectionTitle>
              )
              :null}
              {offer ? <LocalOffer style={{color:'#000'}}/> : null }
            </Box>
            {isConvertCurrency ?
            <SectionTitle pFontSize="14" fontWeight="normal" style={{paddingBottom:'0px',fontWeight:'normal !important'}}>
              {`Pay ${group?.groupPrice} ${group.currency}`}
            </SectionTitle>
            : null}
        </Box>

      </Box>
      <Box
        display="flex"
        flexDirection={matches ? 'row' : 'column'}
        alignItems="flex-start"
        justifyContent="space-between"
        pb={2.5}
      >
        <Box maxWidth={{ xs: '100%', md: '85%' }}>
          <GroupInfo {...group} t={t} fontFamily={fontFamily} />
        </Box>
        <Button
          onClick={() => isAvailable ? handleBooking(group.id) : null}
          size="large"
          variant="contained"
          color="primary"
          style={{fontFamily:fontFamily,alignSelf: matches ? 'unset' : 'flex-end',backgroundColor: isAvailable ? buttonColor ? buttonColor : 'inherit' : '#C8C8C8',color: isAvailable ? buttonFontColor ? buttonFontColor : 'inherit' : '#fff'}}
        >
          {isAvailable ? t && t('companyPage.bookNow') : t && t('companyPage.unavailable')}
        </Button>
      </Box>
    </Box>
  );
};

const GroupInfo = ({ startDate, endDate, durationDays, numberDays, availableSeats, subscription,groupType, fontFamily, t }) => {
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" color="#15476D">
      {groupType === 'subscription' ?
        <Box
          display="flex"
          alignItems="center"
          mr={1.5}
          mb={1}
          width={{ xs: '100%', md: 'auto' }}
          maxWidth={{ xs: '100%', md: '200px' }}
          style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
        >
          <IconWrapper mx={1}>
          <Today />
          </IconWrapper>
          <Box fontWeight={700}>
            <Typography style={{ fontWeight: 500,fontSize:'1rem', fontFamily:fontFamily,color:'#928F8F' }}>{t && t('companyPage.period')}</Typography>
            <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:fontFamily,textTransform:'capitalize'}}>
              {`${subscription} ${subscription === 'custom period' ? "("+numberDays+")" : ''}`}
            </Typography>
          </Box>
        </Box>
      : null }

      {/* start date */}
      {groupType === 'course' ?
        <Box
          display="flex"
          alignItems="center"
          mr={1.5}
          mb={1}
          width={{ xs: '80%', md: 'auto' }}
          maxWidth={{ xs: '80%', md: '170px' }}
          style={{textOverflow: 'ellipsis',whiteSpace: 'nowrap',overflow: 'hidden'}}
        >
          <IconWrapper mx={1}>
            <Today />
          </IconWrapper>
          <div>
            <Typography style={{ fontWeight: 500,fontSize:'1rem', fontFamily:fontFamily,color:'#928F8F' }}>{t && t('reservation.start-date')}</Typography>
            <Typography color="textSecondary" style={{fontSize:'0.9rem', fontFamily:fontFamily}}>
              {moment(startDate * 1000).format('Do MMM YYYY')}
            </Typography>
          </div>
        </Box>
      : null }
      
      {groupType === 'course' ?
      <Box
        display="flex"
        alignItems="center"
        mr={3}
        mb={1}
        width={{ xs: '80%', md: 'auto' }}
      >
        <IconWrapper mx={1}>
          <EventAvailable />
        </IconWrapper>
        <Box fontWeight={700}>
          <Typography style={{ fontWeight: 500,color:'#928F8F',fontSize:'1rem' }}>End Date</Typography>
          <Typography color="textSecondary">
            {moment(endDate * 1000).format('Do MMM YYYY')}
          </Typography>
        </Box>
      </Box>
      : null }

      <Box
        display="flex"
        alignItems="center"
        mr={3}
        mb={1}
        width={{ xs: '80%', md: 'auto' }}
      >
        <IconWrapper mx={1}>
          <PeopleAltOutlined />
        </IconWrapper>
        <div>
          <Typography style={{ fontWeight: 500,color:'#928F8F',fontSize:'1rem' }}>Available Seats</Typography>
          <Typography color="textSecondary">{availableSeats}</Typography>
        </div>
      </Box>
    </Box>
  );
};

const Reviews = ({ reviews, t, data, matches,customCls }) => {
  const { setPage, count, currentItems } = useMyPagination(reviews, 3);

  return (
    <Box width="100%" pb={3} className={customCls || ''}>
      <OverviewSectionTitle>
        {t && t('companyPage.reviews')}
      </OverviewSectionTitle>
      <div>
        {currentItems?.map((item, i) => (
          <ReviewItem key={i} review={item} data={data} matches={matches} />
        ))}
      </div>
      <MyPagination count={count} onChange={setPage} />
    </Box>
  );
};

const ReviewItem = ({ review, data, matches }) => {
  const classes = useRatingStyles();
  
  return (
    <Box
      color="#15476D"
      display="flex"
      flexDirection="column"
      py={3}
      px={3}
      mb={3}
      bgcolor="#FAFAFA"
      border="1px solid #DDDDDD"
    >
      <Box mb={3} display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box width="50px" height="50px" borderRadius="50%" mr={2} style={{border:'1px solid rgb(239, 239, 239)'}}>
          <ImgLazyLoad>
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={review.parentAvatar || imgProfile}
              alt={review.parentName || 'profile'}
            />
          </ImgLazyLoad>
          </Box>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: 600, textTransform:'capitalize' }}>
              {review.parentName || '---'}
            </Typography>
            <Typography variant="subtitle2" color="textPrimary">
              {review.reviewDate ? moment(new Date(review.reviewDate*1000)).format('D MMM YYYY') : '---'}
            </Typography>
          </div>
        </Box>
        <Rating
          classes={{
            iconHover:classes.iconHover,
            iconFilled:classes.iconFilled,
            iconEmpty:classes.iconEmpty,
            icon:classes.icon
          }}
          name="review-rating"
          value={Number(review.rating)}
          precision={0.1}
          readOnly
          emptyIcon={<StarBorder fontSize="inherit" />}
        />
      </Box>
      <Box pl={8}>
        <Typography color="textPrimary">{review.comment}</Typography>
      </Box>
      { review.reply ? <ReviewReply review={review} data={data} matches={matches} /> : null }
    </Box>
  );
};

const ReviewReply = ({review, data,matches}) => {
  const { avatar, name } = data.companyData || {};
  return(
    <Box
      color="#15476D"
      py={3}
      px={3}
      mt={2}
      width={matches ? "calc(100% - 112px)" : "calc(100% - 48px)"}
      alignSelf="flex-end"
      bgcolor="#fff"
      border="1px solid #DDDDDD"
    >
      <Box mb={3} display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box width="50px" height="50px" borderRadius="50%" mr={2} style={{border:'1px solid rgb(239, 239, 239)'}}>
            <ImgLazyLoad>
            <img
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={avatar || imgProfile}
              alt={name || 'profile'}
            />
            </ImgLazyLoad>
          </Box>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: 600, textTransform:'capitalize' }}>
              {name || '---'}
            </Typography>
            <Typography variant="subtitle2" color="textPrimary">
              {review.replyDate ? moment(new Date(review.replyDate*1000)).format('D MMM YYYY') : '---'}
            </Typography>
          </div>
        </Box>
      </Box>
      <Box>
        <Typography color="textPrimary">{review.reply}</Typography>
      </Box>
    </Box>
  )
};

const TabButtons = ({activeTab,handleChange,isRTL,t,fontFamily, buttonColor, buttonFontColor, schedule}) => {
  const classes = useStyles({buttonFontColor});
  const tabFontColor = buttonFontColor ? buttonFontColor : '#fff';
  return(
    <CustomTabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        classes={{indicator:classes.indicator}}
        style={{backgroundColor: buttonColor ? buttonColor : '#fac400'}}
    >
        <CustomTab style={{fontFamily,color: tabFontColor}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('companyPage.overview')} value="one" {...a11yProps('one')} />
        {!schedule ? <CustomTab style={{fontFamily,color: tabFontColor}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('companyPage.booking')} value="two" {...a11yProps('two')} /> : null}
        <CustomTab style={{fontFamily,color: tabFontColor}} className={isRTL === 'ar' ? classes.marLeft : classes.marRight} label={t && t('companyPage.reviews')} value="three" {...a11yProps('three')} />
    </CustomTabs>
  )
}



const InstructorInfo = ({ reviews, memberId, fontFamily, fontFamily2, t, online, data, matches, schedule, course }) =>{
  const isMounted = React.useRef(null);
  const [name,setName] = React.useState('');
  const [avatar,setAvatar] = React.useState('');
  const classes = useStyles();
  const classes2 = useRatingStyles();
  const [, isRTL, ] = useRTL();
  const { facebookPage, twitterPage, whatsappNumber } = data.companyData || {};
  const path = window.location.href;

  React.useEffect(()=> {
    isMounted.current = true;
    if(memberId && isMounted.current) {
      db.ref(`PartnerTeams/${memberId}`).once('value',(data)=>{
        const memberData = data.val();
        if(memberData) {
          setName(`${memberData.firstName} ${memberData.lastName}`);
          setAvatar(memberData?.avatar || '');
        }
        else{
          setName('');
          setAvatar('');
        }
      })
    };
    return () => {
      isMounted.current = false;
    }
  },[memberId]);

  const shareEvent = link => {
    window.open(link,'_blank');
  }


  const actions = [
    { icon: <Twitter className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://twitter.com/${twitterPage}`), visible: twitterPage },
    { icon: <Facebook className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://facebook.com/${facebookPage}`), visible: facebookPage },
    { icon: <WhatsApp className={classes.shareIcon} />, clickEvent: () => shareEvent(`https://wa.me/${whatsappNumber}`), visible: whatsappNumber },
  ];

  return(
    <Box display="flex" flexDirection="column" justifyContent="center">
      {/* instructor info */}
      {!matches ?
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" pt={3}>
        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
          <Box width="45px" height="45px" mx={2} borderRadius="50%" style={{backgroundColor:'#fff',border:'2px solid #fff'}}>
          <ImgLazyLoad>
            <img
              style={{ width: '100%', height: '100%', borderRadius: '50%' }}
              src={avatar || imgProfile2}
              alt={name || 'profile'}
            />
          </ImgLazyLoad>
          </Box>
          <Typography variant="subtitle2" style={{color:'#fff',fontSize:'1.1rem',lineHeight:2,textTransform:'capitalize'}}>{name ? name : '---'}</Typography>
        </div>
        {online && name ? <Box height="2px" width="28px" bgcolor="#fff" mx={1} /> : null }
        {online ?
        <Chip
          label="Online"
          style={{
            marginLeft: '1em',
            borderRadius: 0,
            color: 'white',
            backgroundColor: '#FAC400',
          }}
        />
        : null }
      </Box>
      : null}

      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" pt={{md: 2, xs:0}} pb={matches && (!schedule || !course) ? '20px' : 'unset'}>
        <Rating
          classes={{root:classes2.root,iconHover:classes2.iconHover,iconFilled:classes2.iconFilled,icon:classes2.icon,iconEmpty:classes2.iconEmpty}}
          name="half-rating-read"
          value={calculateRating(reviews)}
          precision={0.1}
          readOnly
          emptyIcon={<StarBorder fontSize="inherit" />}
        />
        <Typography style={{color:'#fff',padding:'0px 8px'}}>{t && t('service.review',{count:reviews.length})}</Typography>
      </Box>

      {schedule && matches ?
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" pb={{xs: '20px', md: '0px'}}>
          <Box display="flex" flexDirection="row" alignItems="center" style={{padding:`0px ${isRTL ? '0px' : '12px'} 0px ${isRTL ? '12px' : '0px'}`}}>
            <div className={classes.iconMbImg} style={{padding:`0px ${isRTL ? '0px' : '5px'} 0px ${isRTL ? '5px' : '0px'}`}}>
              <img src={AppointmentMBIcon} alt='appointment' />
            </div>
            <span style={{fontFamily,fontSize:'10px',color:'#EFFCFF'}}>{t && t('companyPage.appointment')}</span>
          </Box>

          <Box display="flex" flexDirection="row" alignItems="center">
            <div className={classes.iconMbImg} style={{padding:`0px ${isRTL ? '0px' : '5px'} 0px ${isRTL ? '5px' : '0px'}`}}>
              <img src={LocationMBIcon} alt='location' />
            </div>
            <span style={{fontFamily,fontSize:'10px',color:'#EFFCFF'}}>{t && t(`companyPage.${schedule.location === 'Online video Conference' ? 'online' : 'offline'}`)}</span>
          </Box>
      </Box>
      : course && matches ?
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" pb={matches ? '20px' : '0px'}>
          <Box display="flex" flexDirection="row" alignItems="center" style={{padding:`0px ${isRTL ? '0px' : '12px'} 0px ${isRTL ? '12px' : '0px'}`}}>
            <div className={classes.iconMbImg} style={{padding:`0px ${isRTL ? '0px' : '5px'} 0px ${isRTL ? '5px' : '0px'}`}}>
              <img src={AppointmentMBIcon} alt='event' />
            </div>
            <span style={{fontFamily,fontSize:'10px',color:'#EFFCFF'}}>{t && t('acti-comp.cat-option.event')}</span>
          </Box>

          <Box display="flex" flexDirection="row" alignItems="center">
            <div className={classes.iconMbImg} style={{padding:`0px ${isRTL ? '0px' : '5px'} 0px ${isRTL ? '5px' : '0px'}`}}>
              <img src={LocationMBIcon} alt='location' />
            </div>
            <span style={{fontFamily,fontSize:'10px',color:'#EFFCFF'}}>{t && t(`companyPage.${course.location === 'Online video Conference' ? 'online' : 'offline'}`)}</span>
          </Box>
      </Box>
      : null}

      {!matches ?
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center"> 
          {actions.map(v=> {
            if(v.visible) {
              return(
                <div className={classes.shareDiv} onClick={v.clickEvent}>
                  {v.icon}
                </div>
              )
            }
          })}
      </Box>
      : null}
    </Box>
  )
}

const InstructorMBInfo = ({ memberId, data }) =>{
  const isMounted = React.useRef(null);
  const { companyData } = data || {};
  const ownerId = companyData?.owner || ''
  const [name,setName] = React.useState('');
  const [avatar,setAvatar] = React.useState('');
  const tableName = memberId === 'myself' ? `Partners/${ownerId}` : `PartnerTeams/${memberId}`;
  React.useEffect(()=> {
    isMounted.current = true;
    if(memberId && isMounted.current) {
      db.ref(tableName).once('value',(data)=>{
        const memberData = data.val();
        if(memberData) {
          setName(`${memberData.firstName} ${memberData.lastName}`);
          setAvatar(memberData?.avatar || '');
        }
        else{
          setName('');
          setAvatar('');
        }
      })
    };
    return () => {
      isMounted.current = false;
    }
  },[memberId]);


  return(
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-end">
      {/* instructor info */}
      <Box width="36px" height="36px" borderRadius="50%" style={{backgroundColor:'#fff'}}>
        <ImgLazyLoad>
          <img
            style={{ width: '100%', height: '100%', borderRadius: '50%' }}
            src={avatar || imgProfile2}
            alt={name || 'profile'}
          />
        </ImgLazyLoad>
      </Box>
      <Typography variant="subtitle2" style={{color:'#000000',fontSize:'0.625',lineHeight:2,textTransform:'capitalize'}}>{name ? name : '---'}</Typography>
    </Box>
  )
};

const CustomInfoDiv = ({iconImg,title,subTitle,textTransform,...props}) => {
  const classes = useStyles();
  const [, isRTL,  fontFamily] = useRTL();
  const xsMatches = useMediaQuery(theme.breakpoints.down('sm'));

  return(
    <Box className={classes.scheduleBtns} {...props}>
      <div className={classes.iconImg} style={{padding:`0px ${isRTL ? '0px' : '26px'} 0px ${isRTL ? '26px' : '0px'}`}}>
        <img src={iconImg} alt="icon"/>
      </div>
      <div className={classes.customInfoSpanDiv}>
        <span style={{fontFamily,color:'#15476D',fontSize:xsMatches ? '16px' : '18px',fontWeight:500,textTransform: textTransform || 'capitalize'}}>{title}</span>
        <span style={{fontFamily,color:'#000000',fontSize:xsMatches ? '14px' : '20px',textTransform:'capitalize'}}>{subTitle}</span>
      </div>
    </Box>
  )
}


export default ServiceDetails;
